import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CKEditorComponent } from '@ckeditor/ckeditor5-angular';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
// import FontColor from '@ckeditor/ckeditor5-font/src/fontcolor';
// import * as FontColor from '@ckeditor/ckeditor5-font/src/fontColor';
import { FontTransformation } from 'src/ThirdParty/transHindiFont';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit {
  Editor: any = ClassicEditor;
  fontConvClass = new FontTransformation();
  @Input() showPreview: boolean = false;
  @Input() label: string = '';
  @Input() mode: 'VIEW' | 'EDIT' = 'EDIT';
  @Input() basicMode: boolean = false;
  public dataForm = new UntypedFormGroup({
    description: new UntypedFormControl(null),
    lang: new UntypedFormControl('en')
  });
  isTransliterationEnabled: boolean = false;
  @Input() public set defaultLang(id: any) {
    if (id) {
      const lan = ['en', 'ta', 'hi']
      const selectedLang = lan[+id - 1];
      this.dataForm.patchValue({ lang: selectedLang });
      this.isTransliterationEnabled = false; // Default to "font typing" (Direct mapping)
    }
  }
  Lang = [{ id: 'en', name: 'English' }, { id: 'ta', name: 'Tamil (Thanglish)' }, { id: 'hi', name: 'Hindi (Hinglish)' }];
  showLangDd: boolean = false;
  formDataPreview: string = '';
  lastText: string = '';
  isRecording = false;
  recognition: any;
  suggestions: string[] = [];
  selectedIndex: number = 0;
  showSuggestions: boolean = false;
  suggestionPosition = { top: 0, left: 0 };
  currentWord: string = '';
  public editorConfig = {
    // plugins: [FontColor],
    fontFamily: {
      options: [
        'default',
        'Courier New, Courier, monospace',
        'Georgia, serif',
        'Lucida Sans Unicode, Lucida Grande, sans-serif',
        'Tahoma, Geneva, sans-serif',
        'Times New Roman, Times, serif',
        'Trebuchet MS, Helvetica, sans-serif',
        'Verdana, Geneva, sans-serif',
        'Roboto, sans-serif',
        'Bamini, serif',
        'Senthamizh, serif'
      ],
      supportAllValues: true
    },
    language: 'ta',
    fontColor: {
      colors: [
        {
          color: 'hsl(0, 0%, 0%)',
          label: 'Black'
        },
        {
          color: 'hsl(0, 0%, 30%)',
          label: 'Dim grey'
        },
        {
          color: 'hsl(0, 0%, 60%)',
          label: 'Grey'
        },
        {
          color: 'hsl(0, 0%, 90%)',
          label: 'Light grey'
        },
        {
          color: 'hsl(0, 0%, 100%)',
          label: 'White',
          hasBorder: true
        },
        // More colors.
        // ...
      ]
    },
    toolbar: [
      'heading', 'bulletedList', 'fontColor', 'fontBackgroundColor', 'numberedList', 'fontSize', 'fontFamily', '|', 'insertTable', '|', 'undo', 'redo', 'bold', '|', 'ImageUpload'
    ],
    startupFocus: 'end'
  };

  private latestContent: any = null;
  @Input() public set content(text: any) {
    this.latestContent = text;
    if (text) {
      this.dataForm.patchValue({ description: text })
    }
  }
  @ViewChild('editor_box', { static: false }) editor_box: CKEditorComponent = {} as CKEditorComponent;
  @ViewChild('langDiv') langDiv: ElementRef = {} as ElementRef;
  @Output() onChangeData: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit(): void { }

  onReady(editor: any) {
    // CKEditor5 initializes asynchronously - if `content` arrived before this event,
    // patchValue() landed on a not-yet-ready editor and was silently dropped. Re-apply
    // whatever the latest content value was now that the editor is actually ready.
    if (this.latestContent) {
      this.dataForm.patchValue({ description: this.latestContent });
    }
    // Inject the CKEditor toolbar natively
    editor.ui
      .getEditableElement()
      .parentElement.insertBefore(
        editor.ui.view.toolbar.element,
        editor.ui.getEditableElement()
      );

    // editor.plugins.set(FontColor)
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
      return new (UploadAdapter as any)(loader);
    };
    editor.editing.view.document.on('clipboardInput', (evt: any, data: any) => {
      const dataTransfer = data.dataTransfer;
      const rtfContent = dataTransfer.getData('text/plain');
      if (!rtfContent) {
        return;
      }
      const viewContent = this.convertText(rtfContent);
      return data.content = editor.data.htmlProcessor.toView(viewContent);
      //const editingView = editor.editing.view;
      //editingView.scrollToTheSelection();
    });
    editor.editing.view.document.on('keydown', (e, data) => {
      if(!data?.domTarget?.ckeditorInstance){
        return;
      }
      
      const rawKeyCode = data.domEvent.keyCode;

      // Handle navigation in suggestion list
      if (this.showSuggestions && this.suggestions.length > 0) {
        if (rawKeyCode === 40) { // Arrow Down
          this.selectedIndex = (this.selectedIndex + 1) % this.suggestions.length;
          data.domEvent.preventDefault();
          e.stop();
          return;
        }
        if (rawKeyCode === 38) { // Arrow Up
          this.selectedIndex = (this.selectedIndex - 1 + this.suggestions.length) % this.suggestions.length;
          data.domEvent.preventDefault();
          e.stop();
          return;
        }
        if (rawKeyCode === 13 || rawKeyCode === 9) { // Enter or Tab
          this.selectSuggestion(this.suggestions[this.selectedIndex]);
          data.domEvent.preventDefault();
          e.stop();
          return;
        }
        if (rawKeyCode === 27) { // Escape
          this.closeSuggestions();
          return;
        }
      }

      // Allow all standard Ctrl/Cmd keyboard shortcuts (e.g. Ctrl+V, Ctrl+C, Ctrl+A, Ctrl+X, Ctrl+Z, etc.)
      if (data.domEvent.ctrlKey || data.domEvent.metaKey) {
        return;
      }

      // Ignore all modifier keys, control/navigation keys, and function keys (e.g. Shift, Control, Alt, Meta, CapsLock, F1-F12)
      if (data.domEvent.key && data.domEvent.key.length > 1) {
        if (rawKeyCode === 8 || rawKeyCode === 46) { // Backspace or Delete
           setTimeout(() => this.updateSuggestions(data.domTarget.ckeditorInstance), 10);
        }
        return;
      } else {
        data.domEvent.stopPropagation();
        data.domEvent.preventDefault();
        e.stop()
      }
      if (!isEmptyObj(data)) {
        this.onKeyup(data.domEvent, data?.domTarget.ckeditorInstance)
      }
    });
  }

  initSpeechRecognition() {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.recognition = new SpeechRecognition();
      this.recognition.continuous = true;
      this.recognition.interimResults = false;
      
      this.recognition.onresult = (event: any) => {
        let finalTranscript = '';
        for (let i = event.resultIndex; i < event.results.length; ++i) {
          if (event.results[i].isFinal) {
            finalTranscript += event.results[i][0].transcript;
          }
        }
        if (finalTranscript && this.editor_box && this.editor_box.editorInstance) {
          this.insertAtCursor(finalTranscript + ' ', '', this.editor_box.editorInstance);
        }
      };

      this.recognition.onerror = (event: any) => {
        console.error("Speech recognition error", event.error);
        if(event.error === 'not-allowed') {
          this.isRecording = false;
        }
      };

      this.recognition.onend = () => {
         this.isRecording = false;
      };
    }
  }

  toggleDictation() {
    if (!this.recognition) {
       this.initSpeechRecognition();
    }
    if (!this.recognition) {
       console.warn("Speech recognition not supported in this browser.");
       return;
    }

    if (this.isRecording) {
      this.recognition.stop();
      this.isRecording = false;
    } else {
      const langMap:any = {
         'en': 'en-US',
         'ta': 'ta-IN',
         'hi': 'hi-IN'
      };
      this.recognition.lang = langMap[this.dataForm.value.lang] || 'en-US';
      this.recognition.start();
      this.isRecording = true;
    }
  }

  getCurrentCursorPosition(parentElement: any) {
    let selection: any = window.getSelection(),
      charCount = -1,
      node;

    if (selection.focusNode) {
      // if (Cursor._isChildOf(selection.focusNode, parentElement)) {
      node = selection.focusNode;
      charCount = selection.focusOffset;

      while (node) {
        if (node === parentElement) {
          break;
        }

        if (node.previousSibling) {
          node = node.previousSibling;
          charCount += node.textContent.length;
        } else {
          node = node.parentNode;
          if (node === null) {
            break;
          }
        }
      }
      //  }
    }
    return charCount;
  }

  onKeyup(e: any, instance: any) {
    const lang = this.dataForm.value.lang;
    if (lang === 'en') {
      this.insertAtCursor(e.key, '', instance);
      return;
    }

    if (this.isTransliterationEnabled) {
      // Mode B: Google Suggestions (Thanglish/Hinglish)
      if (e.key === ' ') {
        if (this.showSuggestions && this.suggestions.length > 0) {
          this.selectSuggestion(this.suggestions[this.selectedIndex]);
          return;
        }
        this.insertAtCursor(' ', '', instance);
        return;
      }
      this.handlePhoneticInput(e.key, instance);
    } else {
      // Mode A: Direct Font Mapping (Default "font typing")
      if (e.key === ' ') {
        this.insertAtCursor(' ', '', instance);
        return;
      }
      this.elementClick(e.key, instance);
    }
    return e;
  }

  handlePhoneticInput(char: string, instance: any) {
    instance?.model?.change((writer: any) => {
      writer.insertText(char, instance.model.document.selection.getFirstPosition());
    });
    this.updateSuggestions(instance);
  }

  async updateSuggestions(instance: any) {
    const selection = instance.model.document.selection;
    const position = selection.getFirstPosition();
    if (!position || !position.parent) {
      this.closeSuggestions();
      return;
    }
    const range = instance.model.createRange(instance.model.createPositionAt(position.parent, 0), position);
    
    let text = '';
    for (const item of range.getItems()) {
      if (item.is('$text') || item.is('$textProxy')) text += item.data;
    }

    const lastSpaceIndex = text.lastIndexOf(' ');
    this.currentWord = lastSpaceIndex === -1 ? text : text.substring(lastSpaceIndex + 1);

    if (this.currentWord.length > 0 && this.isTransliterationEnabled) {
      const itc = this.dataForm.value.lang === 'ta' ? 'ta-t-i0-und' : 'hi-t-i0-und';
      const url = `https://inputtools.google.com/request?text=${this.currentWord}&itc=${itc}&num=5&cp=0&cs=1&ie=utf-8&oe=utf-8&app=test`;
      
      try {
        const response = await fetch(url);
        const data = await response.json();
        
        // Handle different response formats from Google Input Tools
        if (data && data[0] && Array.isArray(data[0][1])) {
           this.suggestions = data[0][1];
           this.selectedIndex = 0;
           this.showSuggestions = true;
           this.repositionDropdown(instance);
        } else if (data && data[0] === 'SUCCESS' && data[1] && data[1][0][1]) {
          this.suggestions = data[1][0][1];
          this.selectedIndex = 0;
          this.showSuggestions = true;
          this.repositionDropdown(instance);
        } else {
          throw new Error('Unexpected API response format');
        }
      } catch (err) {
        console.error('Error fetching suggestions', err);
        const converted = this.convertText(this.currentWord);
        if (converted && converted !== this.currentWord) {
           this.suggestions = [converted];
           this.showSuggestions = true;
           this.repositionDropdown(instance);
        } else {
           this.closeSuggestions();
        }
      }
    } else {
      this.closeSuggestions();
    }
  }

  repositionDropdown(instance: any) {
    const view = instance.editing.view;
    const selection = view.document.selection;
    const position = selection.getFirstPosition();
    const domElement = view.domConverter.viewToDom(position);
    
    if (domElement) {
      const rect = (domElement as any).getBoundingClientRect ? (domElement as any).getBoundingClientRect() : { top: 0, left: 0 };
      this.suggestionPosition = {
        top: rect.top + window.scrollY + 20,
        left: rect.left + window.scrollX
      };
    }
  }

  selectSuggestion(suggestion: string) {
    const instance = this.editor_box.editorInstance;
    if (!instance) return;

    this.insertAtCursor(suggestion + ' ', this.currentWord, instance);
    this.closeSuggestions();
  }

  closeSuggestions() {
    this.showSuggestions = false;
    this.suggestions = [];
    this.selectedIndex = 0;
  }

  elementClick(arg: any, instance: any) {
    const selection = instance.model.document.selection;
    const position = selection.getFirstPosition();
    
    // Create a range from the beginning of the block to the current position
    const range = instance.model.createRange(
        instance.model.createPositionAt( position.parent, 0 ),
        position
    );

    let text = '';
    for ( const item of range.getItems() ) {
        if ( item.is( '$text' ) || item.is( '$textProxy' ) ) {
            text += item.data;
        }
    }

    // Find the last "word" (partially typed English word)
    const lastSpaceIndex = text.lastIndexOf( ' ' );
    const originalText = lastSpaceIndex === -1 ? text : text.substring( lastSpaceIndex + 1 );
    
    // Convert
    const prevData = originalText ? this.revertText(originalText) : '';
    const pData = prevData + arg;
    const appendData = this.convertText(pData);
    
    // Replace and Insert
    this.insertAtCursor(appendData, originalText, instance);
  }

  insertAtCursor(textToInsert: any, textToRemove: any = '', instance: any = {}) {
    instance?.model?.change((writer: any) => {
      const selection = writer.model.document.selection;
      let position = selection.getFirstPosition();

      if (textToRemove) {
        // Find the range to remove
        const start = position.getShiftedBy( -textToRemove.length );
        const rangeToRemove = writer.createRange( start, position );
        writer.remove( rangeToRemove );
        position = start; // Update position to where we removed text
      }
      
      writer.insertText(textToInsert, position);
      
      // Move selection to after the inserted text
      writer.setSelection( position.getShiftedBy( textToInsert.length ) );
    });
  }

  toggleTransliteration() {
    this.isTransliterationEnabled = !this.isTransliterationEnabled;
  }


  revertText(text: string) {
    const lang: any = this.dataForm.value.lang;
    if (typeof (window as any).ConvertToo !== 'function') {
      console.warn('ConvertToo not found, falling back to original text');
      return text;
    }
    return this.fontConvClass.toConvert(text, lang, false)
  }

  convertText(text: string) {
    const lang: any = this.dataForm.value.lang || 'en';
    if (lang == 'en' || typeof (window as any).ConvertToo !== 'function') {
      return text;
    }
    return this.fontConvClass.toConvert(text, lang, true)
  }

  async toggleLangDd(status = false) {
    this.showLangDd = status;
    if (status) {
      setTimeout(this.onfocus.bind(this), 1000)
      console.log(this.langDiv)
      //this.langDiv.nativeElement.focus();
    }
  }
  onfocus() {
    this.langDiv.nativeElement.focus();
  }

  onChangeDescription() {
    this.onChangeData.emit(this.description);
  }


  onSelectLang(id: string) {
    this.dataForm.patchValue({ lang: id });
    this.isTransliterationEnabled = id !== 'en';
    this.toggleLangDd();
  }

  public onSubmit(): void {
  }

  public reset(): void {
    this.dataForm!.reset();
  }

  public get description(): AbstractControl {
    //@ts-ignore
    return this.dataForm!.controls.description.value;
  }
  public get languageLabel(): string {
    const lng = this.dataForm!.controls.lang.value;
    if (lng === 'ta') return 'Thanglish';
    if (lng === 'hi') return 'Hinglish';
    return 'English';
  }

}
export class UploadAdapter {
  private loader;
  constructor(loader: any) {
    this.loader = loader;
    console.log('read file', this.loader);
  }

  upload() {
    return this.loader.file.then(
      (file: File) =>
        new Promise((resolve, reject) => {
          var myReader = new FileReader();
          myReader.onloadend = (e) => {
            resolve({ default: myReader.result });
          };
          myReader.readAsDataURL(file);
        })
    );
  }
}